// extracted by mini-css-extract-plugin
export var bulkPurchaseTable = "_h-0";